export const ACTIVATE_PAYMENT_MODAL = "ACTIVATE_PAYMENT_MODAL";
export const ACTIVATE_USER_REQUEST = "ACTIVATE_USER_REQUEST";
export const ACTIVATE_USER_SUCCESS = "ACTIVATE_USER_SUCCESS";
export const ACTIVATE_USER_FAILURE = "ACTIVATE_USER_FAILURE";

export const FETCH_STUDENT_INFO_REQUEST = "FETCH_STUDENT_INFO_REQUEST";
export const FETCH_STUDENT_INFO_SUCCESS = "FETCH_STUDENT_INFO_SUCCESS";
export const FETCH_STUDENT_INFO_FAILURE = "FETCH_STUDENT_INFO_FAILURE";

export const FETCH_STUDENT_PROFILE_REQUEST = "FETCH_STUDENT_PROFILE_REQUEST";
export const FETCH_STUDENT_PROFILE_SUCCESS = "FETCH_STUDENT_PROFILE_SUCCESS";
export const FETCH_STUDENT_PROFILE_FAILURE = "FETCH_STUDENT_PROFILE_FAILURE";

export const FETCH_PEOPLE_YOU_MAY_KNOW_REQUEST =
  "FETCH_PEOPLE_YOU_MAY_KNOW_REQUEST";
export const FETCH_PEOPLE_YOU_MAY_KNOW_SUCCESS =
  "FETCH_PEOPLE_YOU_MAY_KNOW_SUCCESS";
export const FETCH_PEOPLE_YOU_MAY_KNOW_FAILURE =
  "FETCH_PEOPLE_YOU_MAY_KNOW_FAILURE";

export const UPLOAD_STUDENT_FILE_REQUEST = "UPLOAD_STUDENT_FILE_REQUEST";
export const UPLOAD_STUDENT_FILE_SUCCESS = "UPLOAD_STUDENT_FILE_SUCCESS";
export const UPLOAD_STUDENT_FILE_FAILURE = "UPLOAD_STUDENT_FILE_FAILURE";

export const FETCH_ALL_STUDENT_REQUEST = "FETCH_ALL_STUDENT_REQUEST";
export const FETCH_ALL_STUDENT_SUCCESS = "FETCH_ALL_STUDENT_SUCCESS";
export const FETCH_ALL_STUDENT_FAILURE = "FETCH_ALL_STUDENT_FAILURE";

export const FETCH_STUDENT_YEAR_REQUEST = "FETCH_STUDENT_YEAR_REQUEST";
export const FETCH_STUDENT_YEAR_SUCCESS = "FETCH_STUDENT_YEAR_SUCCESS";
export const FETCH_STUDENT_YEAR_FAILURE = "FETCH_STUDENT_YEAR_FAILURE";

export const FETCH_STUDENT_PROGRAM_REQUEST = "FETCH_STUDENT_PROGRAM_REQUEST";
export const FETCH_STUDENT_PROGRAM_SUCCESS = "FETCH_STUDENT_PROGRAM_SUCCESS";
export const FETCH_STUDENT_PROGRAM_FAILURE = "FETCH_STUDENT_PROGRAM_FAILURE";

export const DELETE_STUDENT_REQUEST = "DELETE_STUDENT_REQUEST";
export const DELETE_STUDENT_SUCCESS = "DELETE_STUDENT_SUCCESS";
export const DELETE_STUDENT_FAILURE = "DELETE_STUDENT_FAILURE";

export const ASSIGN_ROLE_REQUEST = "ASSIGN_ROLE_REQUEST";
export const ASSIGN_ROLE_SUCCESS = "ASSIGN_ROLE_SUCCESS";
export const ASSIGN_ROLE_FAILURE = "ASSIGN_ROLE_FAILURE";

export const ASSIGN_OFFICE_REQUEST = "ASSIGN_OFFICE_REQUEST";
export const ASSIGN_OFFICE_SUCCESS = "ASSIGN_OFFICE_SUCCESS";
export const ASSIGN_OFFICE_FAILURE = "ASSIGN_OFFICE_FAILURE";

export const FETCH_ALL_MEMBER_REQUEST = "FETCH_ALL_MEMBER_REQUEST";
export const FETCH_ALL_MEMBER_SUCCESS = "FETCH_ALL_MEMBER_SUCCESS";
export const FETCH_ALL_MEMBER_FAILURE = "FETCH_ALL_MEMBER_FAILURE";

export const RETRACT_STUDENT_OFFICE_REQUEST = "RETRACT_STUDENT_OFFICE_REQUEST";
export const RETRACT_STUDENT_OFFICE_SUCCESS = "RETRACT_STUDENT_OFFICE_SUCCESS";
export const RETRACT_STUDENT_OFFICE_FAILURE = "RETRACT_STUDENT_OFFICE_FAILURE";

export const FETCH_STUDENTS_BY_MATRIC_REQUEST =
  "FETCH_STUDENTS_BY_MATRIC_REQUEST";
export const FETCH_STUDENTS_BY_MATRIC_SUCCESS =
  "FETCH_STUDENTS_BY_MATRIC_SUCCESS";
export const FETCH_STUDENTS_BY_MATRIC_FAILURE =
  "FETCH_STUDENTS_BY_MATRIC_FAILURE";

export const FETCH_STUDENT_LASTNAME_REQUEST = "FETCH_STUDENT_LASTNAME_REQUEST";
export const FETCH_STUDENT_LASTNAME_SUCCESS = "FETCH_STUDENT_LASTNAME_SUCCESS";
export const FETCH_STUDENT_LASTNAME_FAILURE = "FETCH_STUDENT_LASTNAME_FAILURE";
